var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoVseli(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1327,
    height: 786,
    viewBox: "0 0 1327 786",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 1144,
    height: 984
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1.528,
    y1: -0.111,
    x2: 0.923,
    y2: 0.937,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f81e1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7c0f0f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.068,
    y1: 0.04,
    x2: 0.966,
    y2: 0.927,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-vseli_logo_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1327,
    height: 786
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vseli_logo_2",
    "data-name": "vseli_logo \\u2013 2",
    clipPath: "url(#clip-vseli_logo_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vseli_logo",
    transform: "translate(92 -107)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M78.34,53.522,224.572,1.308c43.583-11.686,78.34,35.073,78.34,78.34v203.69c0,43.267-31.361,93.855-78.34,78.34L78.34,309.462C40.017,288.054,0,274.368,0,231.1V131.872C0,88.605,30.192,71.282,78.34,53.522Z",
    transform: "translate(840.836 305.785)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_1",
    "data-name": "Polygon 1",
    transform: "translate(546.975 357.223) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M108.772,15.992a31.968,31.968,0,0,1,55.379,0L268.659,197.1a31.968,31.968,0,0,1-27.706,47.952H31.989A31.968,31.968,0,0,1,4.283,197.1Z",
    transform: "translate(0.028 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M136.506,39.076,38.166,209.533H234.847L136.506,39.076m0-39.076A31.669,31.669,0,0,1,164.2,15.993L268.687,197.11A31.968,31.968,0,0,1,241,245.053H32.016A31.968,31.968,0,0,1,4.325,197.11L108.816,15.993A31.669,31.669,0,0,1,136.506,0Z",
    transform: "translate(-2.229 0.001)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 812,
    height: 551,
    rx: 84,
    transform: "translate(92 109)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M136.506,39.076,38.166,209.533H234.847L136.506,39.076m0-39.076A31.669,31.669,0,0,1,164.2,15.993L268.687,197.11A31.968,31.968,0,0,1,241,245.053H32.016A31.968,31.968,0,0,1,4.325,197.11L108.816,15.993A31.669,31.669,0,0,1,136.506,0Z",
    transform: "translate(638.974 247.994) rotate(90)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoVseli);
export default __webpack_public_path__ + "static/media/LogoVseli.0bcce2a2.svg";
export { ForwardRef as ReactComponent };